import styled from 'styled-components';

const GridRow = styled.div`
  gap: ${({ gap = '20px' }) => gap};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${({ min = '350px' }) => min}, 1fr));
  justify-content: center;
`;

export default GridRow;
